module.exports = __webpack_public_path__ + "assets/img/empty.58520e3a.png";